export { default } from './ReservationIconDetail';
export * from './ReservationIconDetail';
